import {
	Pipe,
	PipeTransform
}                      from '@angular/core';
import { StringUtils } from '@utils/helpers';

/**
 * Uppercase string with spaces.
 * e.g.: "[fooBar, foo_bar, foo-bar, foo_BAR, Foo_Bar, Foo-Bar]" -> "FOO BAR"
 * e.g.: "[FOO_BAR]" -> "F O O B A R"
 */
@Pipe( {
	name: 'upperCaseSeparated',
	pure: false
} )
export class UpperCaseSeparatedPipe implements PipeTransform {

	constructor() {}

	transform( str: string ): string {
		return StringUtils.toUpperCaseSeparated( str );
	}
}
